import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudButtonModule,
	FreudDialogModule,
	FreudDividerModule,
	FreudTooltipModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { FreudConfirmDialogModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { AppointmentDeleteRecurrencyModalModule } from '../appointment-delete-recurrency-modal/appointment-delete-recurrency-modal.module';
import { AppointmentDetailsFooterComponent } from './appointment-details-footer.component';

@NgModule({
	declarations: [AppointmentDetailsFooterComponent],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudTypographyModule,
		FreudButtonModule,
		FreudConfirmDialogModule,
		FreudDialogModule,
		FreudDividerModule,
		FreudTooltipModule,
		AppointmentDeleteRecurrencyModalModule,
	],
	exports: [AppointmentDetailsFooterComponent],
})
export class AppointmentDetailsFooterModule {}
